import { Injectable } from '@angular/core';
import { Answer } from "../../common/models/answer";
import { EvaluationAthlete } from "../../common/models/evaluation-athlete";

@Injectable({providedIn: 'root'})
export class EvaluationAthleteAnswerProvider {
    constructor(
    ) {}

    /**
     * Find all Answer for an evaluation athlete
     */
    public findByEvaluationAthlete(evaluationAthlete: EvaluationAthlete): Promise<Answer[]> {
        return new Promise<Answer[]>((resolve, reject) => {
          // this.api.call('get', `evaluation-athletes/${evaluationAthlete.id}/answers/`, {}, this._currentUser.getAccessToken())
            // const loadAnswers = new Promise<Answer[]>((resolveEvaluation) => this.storage.select(Answer)
            //     .where('evaluationAthleteId').equals(evaluationAthlete.id)
            //     .get()
            //     .then((answers: Answer[]) => {
            //         resolveEvaluation(answers);
            //     })
            // );

            // Promise.all([loadAnswers]).then((data) => {
            //     data[0].map((answer:any) => {
            //         answer["evaluationAthlete"] = evaluationAthlete;
            //     });
            //
            //     resolve(data[0]);
            // });
        });
    }
}
